import { useContext } from 'react';

import styles from './TopicFilesEditComponent.module.css'

import { GlobalContext } from "../../../contexts/globalContext"
import { ProjectDetailsContext } from "../../../contexts/projectDetailsContext";
import { AddConferenceContext } from "../../../contexts/addConferenceContext"

import TopicsDetailsComponents from './TopicsDetailsComponents';
import FilesDetailsComponent from './FilesDetailsComponent';
import PopupBaseComponent from '../../popup/common/PopupBaseComponent';
import ConferenceAddNewTopicComponent from '../../popup/conferenceDetails/ConferenceAddNewTopicComponent';
import ConferenceAddFilesComponent from '../../popup/conferenceDetails/ConferenceAddFilesComponent';
import DeleteNotificationComponent from '../../popup/common/DeleteNotificationComponent';
import AddModeratorPopup from '../../popup/conferenceDetails/AddModeratorPopup';

import video from '../../../graphics/big wave fundal loop_6.mp4'

const TopicFilesEditComponent = () => {
    const { appHeight } = useContext(GlobalContext)
    const { editConference } = useContext(ProjectDetailsContext)
    const { addNewTopic, openFiles, conferenceAddFiles, deleteClicked, setDeleteClicked, addModerator } = useContext(AddConferenceContext)


    return (
        <PopupBaseComponent width='calc(100% - 135px)' marginLeft='135px' flexDirection='column'>
            <video id="background-video" autoPlay loop playsInline muted style={{ height: `${appHeight}px`, width: '100%' }}>
                <source src={video} type="video/mp4" />
            </video>
            <div className={styles.body}>
                <div className={styles.column} style={{ width: 1994 }}>
                    <TopicsDetailsComponents />
                </div>
                <div className={styles.column} style={{ width: 1600 }}>
                    {openFiles && editConference.topics.length > 0 && <FilesDetailsComponent />}
                </div>
            </div>
            {addNewTopic && <ConferenceAddNewTopicComponent />}

            {conferenceAddFiles && <ConferenceAddFilesComponent />}
            {deleteClicked?.shown === true && <DeleteNotificationComponent deleteClicked={deleteClicked} setDeleteClicked={setDeleteClicked} />}
            {addModerator && !addNewTopic && <AddModeratorPopup />}

        </PopupBaseComponent>
    );

}

export default TopicFilesEditComponent;